import { render, staticRenderFns } from "./medicion-frecuencia.vue?vue&type=template&id=0cfefb70&scoped=true&"
import script from "./medicion-frecuencia.vue?vue&type=script&lang=js&"
export * from "./medicion-frecuencia.vue?vue&type=script&lang=js&"
import style0 from "./medicion-frecuencia.vue?vue&type=style&index=0&id=0cfefb70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfefb70",
  null
  
)

export default component.exports